var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 265.766,
    height: 222.398,
    viewBox: "0 0 265.766 222.398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 104"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 20.3569,
    y1: 74.2622,
    x2: 87.4749,
    y2: 99.4368,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 86.8896,
    y1: 99.4904,
    x2: 154.006,
    y2: 57.5351,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    x1: 87.382,
    y1: 99.404,
    x2: 204.862,
    y2: 124.568,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    x1: 87.5952,
    y1: 100.62,
    x2: 50.0856,
    y2: 124.04,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    x1: 137.389,
    y1: 134.197,
    x2: 49.6572,
    y2: 124.138,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    x1: 205.118,
    y1: 125.744,
    x2: 121.241,
    y2: 192.942,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    x1: 205.071,
    y1: 124.67,
    x2: 255.41,
    y2: 158.23,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    x1: 154.896,
    y1: 57.7066,
    x2: 205.236,
    y2: 124.826,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    x1: 120.161,
    y1: 192.16,
    x2: 136.946,
    y2: 133.432,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    x1: 198.406,
    y1: 15.3749,
    x2: 136.938,
    y2: 133.841,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    x1: 138.722,
    y1: 133.018,
    x2: 204.101,
    y2: 79.932,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    x1: 89.8538,
    y1: 99.3475,
    x2: 204.408,
    y2: 79.7894,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    x1: 49.1008,
    y1: 213.794,
    x2: 86.5405,
    y2: 100.916,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    x1: 49.283,
    y1: 213.513,
    x2: 135.897,
    y2: 134.163,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    x1: 87.6119,
    y1: 99.501,
    x2: 137.951,
    y2: 133.06,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.33172
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 16.2118,
    cy: 72.0767,
    r: 16.2116,
    fill: "#6366F1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    cx: 87.2421,
    cy: 100.056,
    rx: 11.746,
    ry: 11.746,
    fill: "#22D3EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 197.535,
    cy: 16.4849,
    r: 16.4847,
    fill: "#22D3EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 154.363,
    cy: 58.1038,
    r: 10.068,
    fill: "#818CF8"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 204.703,
    cy: 125.227,
    r: 15.102,
    fill: "#22D3EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    cx: 48.3441,
    cy: 124.88,
    r: 9.78698,
    fill: "#0C45CC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    cx: 49.7407,
    cy: 214.008,
    r: 8.38998,
    fill: "#4F46E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 120.802,
    cy: 192.344,
    r: 10.068,
    fill: "#22D3EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 254.702,
    cy: 157.451,
    r: 11.0647,
    fill: "#6366F1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 136.111,
    cy: 132.742,
    r: 7.58679,
    fill: "#1384FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    cx: 204.242,
    cy: 79.0478,
    r: 11.4554,
    fill: "#818CF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGraph);
export default __webpack_public_path__ + "static/media/hero_graph.38c33fe0604517252b54148b84656325.svg";
export { ForwardRef as ReactComponent };